import React from "react";
import { Bar } from "@ant-design/charts";
import { DATA } from "../../../myanfinviz";
import * as _ from "lodash";
export const InvestingCountryBarChart = () => {
  var newData = _.groupBy(DATA, (r) => r["Investing Country"]);
  // newData = _.orderBy(newData, (r) => r.length, "desc");
  newData = _.mapValues(newData, (r) => {
    return { name: r[0]["Investing Country"], value: r.length };
  });
  newData = _.orderBy(newData, (r) => r.value, "desc");
  console.log("InvestingCountryBarChart data", newData);
  var config = {
    data: [...newData],
    xField: "value",
    yField: "name",
    seriesField: "name",
    legend: { position: "top-left" },
  };

  return <Bar {...config} />;
};
